import { __callbacks } from "../Callbacks/Callback";
import { MsgForm } from "../Explorer/MsgForm";
import { MsgReceive } from "../Explorer/MsgReceive";
import { MsgReceiveEx } from "../Explorer/MsgReceiveEx";
import { IBotExMessage, IBotResponseCB, IChatMessageFragment } from "../Interfaces";
import bot from "assets/configs/botEx.json";
import { __bot } from "./Bot";
import { __debug } from "../Debug/Debug";
import { __sb } from "../SB/sb";
import { __pusher } from "../Pusher/pusher";
import { __chats } from "Utils/Chats/Chats";

import { ChatMessageFragment } from "Utils/Chats/ChatMessageFragment";
import ChatMessage from "components/ChatApp/components/ChatMessage/ChatMessage";

class BotResponse {
    private timeout: number = 0;

    public init = () => {
        this.initEvents();
    }

    private initEvents = () => {
        __callbacks.onBotResponse((botResponse: IBotResponseCB) => {
            this.timeout = 0;

            const botResponseArr: IBotExMessage[] = botResponse.response;
            botResponseArr?.forEach((response, index, self) => {
                setTimeout(() => {
                    this.handleResponse(botResponse.chatId, response);

                    const isLastResponse = index === self.length - 1;
                    const isForm = (response.type === "form");
                    const isQuiz = (response.type === "quiz");
                    if (isLastResponse && !isForm && !isQuiz) {
                        __callbacks.enableChatInputs.trigger({
                            chatId: botResponse.chatId,
                        });
                    }
                }, (this.timeout += bot.delay));
            });
        });
    }

    handleResponse = (chatId: string, botMsg: IBotExMessage) => {
        switch (botMsg.type) {
            case "text":
                this.handleTextResponse(chatId, botMsg);
                break;
            case "quiz":
                this.handleQuizResponse(chatId, botMsg);
                break;
            case "navigation":
                this.handleNavigationResponse(chatId, botMsg);
                break;
            case "form":
                //var contact = localStorage.getItem('contact_id' + window.location.search.substr(1).split("&")[0].split("=")[1]);
                //if (contact == null || contact.trim() === '') {
                //    console.log('botresponse 1');
                //    new MsgForm(chatId);
                //} else {
                //    console.log('botresponse 2');
                //    __pusher.createChannel(chatId);
                //    let name = localStorage.getItem('contact_name' + window.location.search.substr(1).split("&")[0].split("=")[1]);
                //    let email = localStorage.getItem('contact_email' + window.location.search.substr(1).split("&")[0].split("=")[1]);
                //    __sb.sendUserDetails(chatId, name || '', email || '');
                //    const botResponse: IBotExMessage[] = __bot.getFormResponse();
                //    __callbacks.botResponse.trigger(__bot.formatResponse(botResponse));
                //}
                break;
            case "image":
                this.handleImageResponse(chatId, botMsg);
                break;
            case "responseId":
                this.handleIdResponse(botMsg);
                break;
            default:
                break;
        }
    }

    handleTextResponse = (chatId: string, response: IBotExMessage) => {
        this.disableChatInputs(chatId);
        if (!(typeof response.value === "string")) {
            __debug.warn(() => {
                console.warn("Expected a string but got other value!");
            });
            return;
        }
        new MsgReceive({
            chatId: chatId,
            userId: __bot.id,
            userName: "bot",
            userPhoto: "./assets/icons/bot.svg",
            fragment: response.fragment ?? true,
            text: response.value,
        });
    }

    handleQuizResponse = (chatId: string, response: IBotExMessage) => {
        this.disableChatInputs(chatId);
        if (!(typeof response.value === "object")) {
            __debug.warn(() => {
                console.warn("Expected an object but got other value!");
            });
            return;
        }
        new MsgReceiveEx({
            chatId: chatId,
            userId: __bot.id,
            userName: "bot",
            userPhoto: "./assets/icons/bot.svg",
            fragment: response.fragment ?? true,
            child: {
                componentName: "Quiz",
                props: { quiz: response.value }
            }
        });
    }

    handleNavigationResponse = (chatId: string, response: IBotExMessage) => {
        this.disableChatInputs(chatId);
        if (!(typeof response.value === "object")) {
            __debug.warn(() => {
                console.warn("Expected an object but got other value!");
            });
            return;
        }
        new MsgReceiveEx({
            chatId: chatId,
            userId: __bot.id,
            userName: "bot",
            userPhoto: "./assets/icons/bot.svg",
            fragment: response.fragment ?? true,
            child: {
                componentName: "Navigation",
                props: { ...response.value }
            }
        });
    }

    handleImageResponse = (chatId: string, response: IBotExMessage) => {
        this.disableChatInputs(chatId);
        if (!(typeof response.value === "object")) {
            __debug.warn(() => {
                console.warn("Expected an object but got other value!");
            });
            return;
        }
        new MsgReceiveEx({
            chatId: chatId,
            userId: __bot.id,
            userName: "bot",
            userPhoto: "./assets/icons/bot.svg",
            fragment: response.fragment ?? true,
            child: {
                componentName: "Image",
                props: { ...response.value }
            }
        });
    }

    handleIdResponse = (response: IBotExMessage) => {
        __callbacks.userResponse.trigger(response.value);
    };

    disableChatInputs = (chatId: string) => {
        __callbacks.disableChatInputs.trigger({
            chatId
        });
    }
}

export const __botResponse = new BotResponse();
